/* eslint-disable camelcase */
import { AxiosResponse } from "axios";
import { v1 as uuidv1 } from "uuid";

import { IItsmePost, IItsmePre, ItsmeUserInfo } from "@/shared/domain/auth";

import { getIdpApi, requestConfig } from "./apiRoot";

// More info: https://ci.portima.net/apidoc/ip/#api-IP_JSON-PostItfs_sSc2ipFauth

export const spname = "PI2_IBP/SP/Portima/Brio/Ibp/Next"; // spName of IBP/CS = External App => External IdP
export const host = "MYBROKDER-REACT-CLIENT";
export const hostItsme = "feaswebdev01";

interface FAuthPayload {
    status: string;
}

export const fAuth = (email: string, password: string): Promise<AxiosResponse<FAuthPayload>> => {
    const body = {
        header: { host },
        credential: { authClsInst: "FORM", id: email },
        info: { step: 0, devId: "myBroker", password },
    };
    const axiosRequestConfig = requestConfig({ withCredentials: true });

    return getIdpApi().post<FAuthPayload>("fAuth", body, axiosRequestConfig);
};

export const fAuthItsme = async (itsmeUserId: string, itsmeToken: string): Promise<AxiosResponse<FAuthPayload>> => {
    const body = {
        header: { host: hostItsme },
        credential: { authClsInst: "EXT[oAuth/itsme]", id: itsmeUserId },
        info: { step: 0, devId: "myBroker", token: itsmeToken },
    };
    const axiosRequestConfig = requestConfig({ withCredentials: true });
    return getIdpApi().post("fAuth", body, axiosRequestConfig);
};

interface FSamlPayload {
    status: string;
    artifact: string;
}

export const fSaml = async (office: string, fromItsMe = false): Promise<FSamlPayload> => {
    const date = JSON.parse(JSON.stringify(new Date()));
    const body = {
        header: { host },
        saml: {
            guid: uuidv1(),
            issueInstant: date,
            issuer: spname,
            o: office,
            so: "$i",
            ttOut: "JWTV1",
        },
    };
    const axiosRequestConfig = requestConfig({ withCredentials: true });
    const { data } = await getIdpApi().post<any, AxiosResponse<FSamlPayload | MyBrokerApi.ApiError>>(
        `fSaml${fromItsMe ? "?pi2.bSamlEmbedded=1" : ""}`,
        body,
        axiosRequestConfig,
    );

    return data as FSamlPayload;
};

interface FOfficeSubOfficeSpGetPayload {
    status: string;
    res: string[][];
}

export const fOfficeSubOfficeSpGet = async (): Promise<FOfficeSubOfficeSpGetPayload> => {
    const body = {
        header: { host },
        info: { o: "%", so: "%", sp: spname, cols: "office,suboffice" },
    };
    const axiosRequestConfig = requestConfig({ withCredentials: true });
    const { data } = await getIdpApi().post<any, AxiosResponse<FOfficeSubOfficeSpGetPayload>>(
        "fOfficeSubOfficeSpGet",
        body,
        axiosRequestConfig,
    );
    return data;
};

export const fItsmePre = async (currentUrl: string): Promise<IItsmePre> => {
    const axiosRequestConfig = requestConfig({
        params: {
            bPi2: "1",
            bEid: "0",
            urlCallback: currentUrl,
        },
    });

    const { data } = await getIdpApi().get<IItsmePre>("fItsmePre", axiosRequestConfig);
    return data;
};

export const fItsmePost = async (token: string): Promise<ItsmeUserInfo> => {
    const axiosRequestConfig = requestConfig({
        params: {
            state: token,
        },
    });

    const { data } = await getIdpApi().get<IItsmePost>(`fItsmePost`, axiosRequestConfig);

    const jwtUser = data.jwtUser;
    const birthdate = new Date(`${jwtUser.birthdate}T00:00:00.000Z`);

    return {
        itsmeId: data.sub,
        itsmeToken: data.pi2?.guidToken,
        email: data.jwtUser?.email,
        emailVerified: data.jwtUser?.email_verified,
        firstName: data.jwtUser?.given_name,
        lastName: data.jwtUser?.family_name,
        phoneNumber: data.jwtUser?.phone_number,
        birthdate,
    };
};
